module.exports = __webpack_public_path__ + "static/bg3-e76de24b6d8ab5e920bb4d49241ad15f.jpg";